<template>
  <header class="flex | bg-white | rounded-2xl | p-8">
    <h1 class="font-serif | px-8">{{ title }}</h1>
    <button class="btn | ml-auto" disabled>Demander un RDV</button>
  </header>
</template>

<script setup>
const { title } = defineProps({
  title: String,
});
</script>
